"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.questionMarkRegExp = exports.onlyNumLertterHanziRegExp = exports.numStartRegExp = exports.numEndRegExp = exports.commaRegExp = exports.numRegExp = exports.noneRegExp = exports.excelTypeRegExp = exports.ezbuySystemRegExp = exports.litbAdorSystemRegExp = exports.litbSystemRegExp = exports.hasBlankRegExp = exports.enRegExp = exports.allLettersRegExp = exports.litbDev0RegExp = exports.tboxMeDomainRegExp = exports.emallCnDomainRegExp = exports.emallNetDomainRegExp = exports.ezbuyDevDomainRegExp = exports.userAgentMobileRegExp = exports.androidRegExp = exports.iosRegExp = exports.userAgentRegExp = void 0;

/**
 * 公用的正则
 */
var userAgentRegExp = /\[((?:[\w\d]+\/[\w\d\.\s-=,]+;?)+)\]$/i;
exports.userAgentRegExp = userAgentRegExp;
var iosRegExp = /\(i[^;]+;( U;)? CPU.+Mac OS X/;
exports.iosRegExp = iosRegExp;
var androidRegExp = /Android|Adr/i;
exports.androidRegExp = androidRegExp;
var userAgentMobileRegExp = /iPhone|iPod|iPad|ios|Android|Windows Phone|SymbianOS|Mobile|BlackBerry|IEMobile|Silk/i;
exports.userAgentMobileRegExp = userAgentMobileRegExp;
var ezbuyDevDomainRegExp = /(?:ezbuy.dev$)/;
exports.ezbuyDevDomainRegExp = ezbuyDevDomainRegExp;
var emallNetDomainRegExp = /(?:65emall.net$)/;
exports.emallNetDomainRegExp = emallNetDomainRegExp;
var emallCnDomainRegExp = /(?:65emall.cn$)/;
exports.emallCnDomainRegExp = emallCnDomainRegExp;
var tboxMeDomainRegExp = /(?:tbox.me$)/;
exports.tboxMeDomainRegExp = tboxMeDomainRegExp;
var litbDev0RegExp = /(?:kdev0\-tights\.lightinthebox.com$)/; // 全局匹配忽略大小写、只能是26字母

exports.litbDev0RegExp = litbDev0RegExp;
var allLettersRegExp = /^[a-zA-Z]+$/ig; // 匹配en、EN

exports.allLettersRegExp = allLettersRegExp;
var enRegExp = /^en$/gi; // 是否有空格

exports.enRegExp = enRegExp;
var hasBlankRegExp = /\s/g; // litb系统

exports.hasBlankRegExp = hasBlankRegExp;
var litbSystemRegExp = /litb/gi; // litbador系统

exports.litbSystemRegExp = litbSystemRegExp;
var litbAdorSystemRegExp = /litbador/gi; // ezbuy系统

exports.litbAdorSystemRegExp = litbAdorSystemRegExp;
var ezbuySystemRegExp = /ezbuy/gi; // 判断是否是excel

exports.ezbuySystemRegExp = ezbuySystemRegExp;
var excelTypeRegExp = /.xls$|.xlsx$/i; // 判断是否是none

exports.excelTypeRegExp = excelTypeRegExp;
var noneRegExp = /none/gi; // 全是数字

exports.noneRegExp = noneRegExp;
var numRegExp = /^\d+$/; // 逗号

exports.numRegExp = numRegExp;
var commaRegExp = /[\uff0c]/g; // 以数字结尾

exports.commaRegExp = commaRegExp;
var numEndRegExp = /\d+$/; // 以数字开头

exports.numEndRegExp = numEndRegExp;
var numStartRegExp = /^\d+/; // 数字、字母、汉字

exports.numStartRegExp = numStartRegExp;
var onlyNumLertterHanziRegExp = /^[\u4e00-\u9fa5\w]*$/g; // 问号

exports.onlyNumLertterHanziRegExp = onlyNumLertterHanziRegExp;
var questionMarkRegExp = /\?/gi;
exports.questionMarkRegExp = questionMarkRegExp;